import * as yup from 'yup';

export const prepareFormData = (obj: unknown): unknown => {
  if (obj === null || obj === undefined) {
    return null;
  }

  if (typeof obj !== 'object') {
    if (typeof obj === 'string') {
      const currentString = obj as string;
      return currentString.trim() === '' ? null : currentString.trim();
    }
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(prepareFormData);
  }

  const cleanedObj: Record<string, unknown> = {};

  Object.keys(obj).forEach((key) => {
    cleanedObj[key] = prepareFormData((obj as Record<string, unknown>)[key]);
  });

  return cleanedObj;
};

const LETTERS = '\\p{Script=Latin}\\p{Script=Cyrillic}\\p{M}';

const buildNameAddressRegExp = (isAddress: boolean): RegExp => {
  const filler = `[${LETTERS}${isAddress ? '0-9,' : ''}. ]`;

  return new RegExp(`^${filler}+(?:['’-]${filler}+)*$`, 'u');
};

const buildNameAddressSchema = (isAddress: boolean) =>
  yup.string().nullable().matches(buildNameAddressRegExp(isAddress), {
    excludeEmptyString: true,
    message: 'common.formValidation.invalidCharacters',
  });

export const personNameFieldSchema = buildNameAddressSchema(false);
export const addressFieldSchema = buildNameAddressSchema(true);

const APOSTROPHE_NORMALIZED_FIELDS = [
  'addressLine1',
  'addressLine2',
  'city',
  'firstName',
  'lastName',
  'state',
];

export const normalizeNameAddressApostrophes = <T extends object>(values: T): T => {
  const result = { ...values } as Record<string, unknown>;

  APOSTROPHE_NORMALIZED_FIELDS.forEach((key) => {
    const value = result[key];

    if (typeof value === 'string') {
      result[key] = value.replace(/’/g, "'");
    }
  });

  return result as T;
};
